import React from "react";
import { AnimateFrame } from "../../components/AnimateFrame";
import { Header } from "../../components/Header";
import { Projects } from "../../components/Projects";
import { Container } from "../../style/GlobalStyle";

export const ProjectsPage = () => {
  return (
    <Container>
      <Header />
      <AnimateFrame>
        <Projects />
      </AnimateFrame>
    </Container>
  );
};
